// Busca das listas de seleção (cidades, bairros, CNAE). As listas vêm sem acento do backend, então a
// busca também ignora acento e maiúsculas: quem digita "São" encontra "Sao Paulo".
export function semAcento(texto) {
  return String(texto ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();
}

// Limite de itens desenhados: a lista de bairros da cidade de São Paulo passa de 39 mil.
export const LIMITE_SEM_BUSCA = 50;
export const LIMITE_COM_BUSCA = 300;

export function filtrarOpcoes(opcoes, filtro) {
  const termo = semAcento(filtro).trim();
  const encontradas = termo ? opcoes.filter((opt) => semAcento(opt).includes(termo)) : opcoes;
  const limite = termo ? LIMITE_COM_BUSCA : LIMITE_SEM_BUSCA;
  return { visiveis: encontradas.slice(0, limite), total: encontradas.length };
}

export function avisoDaLista({ visiveis, total }, filtro) {
  if (total === 0) return filtro.trim() ? "Nenhum resultado para essa busca." : "";
  if (total <= visiveis.length) return "";
  const fmt = (n) => n.toLocaleString("pt-BR");
  return `Mostrando ${fmt(visiveis.length)} de ${fmt(total)}. Digite para filtrar.`;
}
